/* import __COLOCATED_TEMPLATE__ from './priority-changed-by-rule.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import Component from '@glimmer/component';
import { EntityType } from 'embercom/models/data/entity-types';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import LinkWithText from 'embercom/helpers/link-with-text';
import { createSafeAdminLink } from 'embercom/utils/admin-link';
import type RenderablePart from 'embercom/objects/inbox/renderable-part';
import type PriorityChangedByRule from 'embercom/objects/inbox/renderable/priority-changed-by-rule';
import type AdminSummary from 'embercom/objects/inbox/admin-summary';
import { truncateEventText, isEventTextTruncated } from 'embercom/lib/inbox2/event-text-truncation';

interface PriorityChangedByRulePart extends RenderablePart {
  renderableData: PriorityChangedByRule;
}

interface Args {
  part: PriorityChangedByRulePart;
}

interface Signature {
  Args: Args;
}

export default class Inbox2ConversationStreamEventPartsPriorityChangedByRuleComponent extends Component<Signature> {
  @service declare session: Session;

  // @ts-ignore helper doesn't seem to be typed correctly
  linkWithTextHelper = LinkWithText.create(this);

  get creatingEntity() {
    return this.args.part.renderableData.creatingEntity.object;
  }

  get operatorName() {
    return createSafeAdminLink(this.creatingEntity as AdminSummary, this.linkWithTextHelper);
  }

  entityType = EntityType;

  truncateTitle(title: string | undefined): string {
    return truncateEventText(title);
  }

  isTitleTruncated(title: string | undefined): boolean {
    return isEventTextTruncated(title);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::EventParts::PriorityChangedByRule': typeof Inbox2ConversationStreamEventPartsPriorityChangedByRuleComponent;
    'inbox2/conversation-stream/event-parts/priority-changed-by-rule': typeof Inbox2ConversationStreamEventPartsPriorityChangedByRuleComponent;
  }
}
